window.addEventListener('DOMContentLoaded', () => {
    const faqItems = document.querySelectorAll<HTMLElement>('.faq-item');

    faqItems?.forEach(item => {
        const question = item.querySelector<HTMLElement>('.faq-question');

        question?.addEventListener('click', () => {
            const isActive = item.classList.contains('active');

            faqItems.forEach(otherItem => {
                if (otherItem !== item) {
                    otherItem.classList.remove('active');
                }
            });

            item.classList.toggle('active', !isActive);
        });
    });
});